<div class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Exportar Curva ABC de Vendas para Excel
                </h4>        
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <ng-template [ngIf]="entityModal">
                        <div class="row">
                            <div class="col-12">
                                <div class="alert alert-info">
                                    <i class="fas fa-info" aria-hidden="true"></i> A exportação irá considerar a perspectiva selecionada, filtros e ordenação aplicados na consulta atual.
                                </div>
                            </div>
                        </div> 
                        
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="nomeExportacao" class="col-form-label">Nome da Exportação</label>
                                <input type="text" class="form-control" [(ngModel)]="entityModal.nomeExportacao" name="nomeExportacao" id="nomeExportacao" 
                                    #nomeExportacaoModel="ngModel" required="required">
                                <p class="form-text text-muted" style="margin-top:0px;">Será o nome do arquivo Excel exportado.</p>                                                                             
                                <sgt-form-control-error
                                    *ngIf="nomeExportacaoModel.errors && nomeExportacaoModel.errors.required && nomeExportacaoModel.dirty"
                                    msgError="O nome da exportação é obrigatório">
                                </sgt-form-control-error>
                            </div>
                        </div>
                    </ng-template>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-primary" (click)="export()" id="btnCurvaAbcVendaExcelExport">
                    <i class="far fa-file-excel"></i> Exportar
                </button>              
            </div>            
        </div>
    </div>
</div>